// extracted by mini-css-extract-plugin
export default {"sidebarContanier":"TournamentSidebar_sidebarContanier__PG7r-","disclosed":"TournamentSidebar_disclosed__Dyop2","discloseBtn":"TournamentSidebar_discloseBtn__Hwe6S"};